import * as React from 'react';

import { ThumbDownIcon } from 'bundles/ai-course-coach/assets/mui';
import { CoachIconButton } from 'bundles/ai-course-coach/components/common';

import _t from 'i18n!nls/learning-assistant-chat-ai';

type Props = {
  selected?: boolean;
  onSelect(): void;
  onDeselect(): void;
};

const Dislike = ({ selected, onSelect, onDeselect }: Props) => {
  return (
    <div data-testid="dislike-component">
      {selected ? (
        <CoachIconButton
          size="small"
          data-testid="thumbs-down-filled-icon"
          aria-label={_t('Cancel dislike')}
          tooltip={_t('Cancel dislike')}
          onClick={onDeselect}
          icon={<ThumbDownIcon filled={true} />}
        />
      ) : (
        <CoachIconButton
          size="small"
          data-testid="thumbs-down-icon"
          aria-label={_t('Dislike')}
          tooltip={_t('Dislike')}
          onClick={onSelect}
          icon={<ThumbDownIcon filled={false} />}
        />
      )}
    </div>
  );
};

export default Dislike;
